import React from 'react'
import ConactUsHeader from '../organisms/ContactUsHeader'
import OGScoreBody from '../organisms/OGScoreBody'
import Footer from '../organisms/Footer'
import useScrollToTop from '../../hooks/useScrollToTop'
const OGScorePage = () => {
  useScrollToTop()
  return (
    <div className='bg-gray-100'>
      <ConactUsHeader />
      <OGScoreBody />
      <Footer />
    </div>
  )
}

export default OGScorePage